import React, { useEffect, useState } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { signInRedirect } from '../../services/auth.service'
import roleConstants from '../../constants/roles.constants'
import tokenConstants from '../../constants/token.constants'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router'
import { getUser } from '../../services/auth.service'
import LoadingPage from '../../pages/loadingPage'
import ServiceSelectionRequired from './ServiceSelectionRequired'

function ProtectedRoute({
    serviceSelectedRequired = true,
    requiredRoles,
    component: Component,
    ...rest
}) {
    const location = useLocation()

    const [isLoading, setIsLoading] = useState(true)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [hasRoles, setHasRoles] = useState(false)

    useEffect(() => {
        async function initialiseAccessData() {
            let user
            try {
                user = await getUser()
            } catch (error) {
                console.error(error)
            }

            if (!user) {
                setIsLoading(false)
                return
            }

            let userHasRoles = false
            const rolesRequired = requiredRoles && requiredRoles.length
            if (rolesRequired) {
                if (
                    typeof user.profile[tokenConstants.ROLES] === 'string' &&
                    requiredRoles.length === 1
                ) {
                    userHasRoles =
                        user.profile[tokenConstants.ROLES] === requiredRoles[0]
                } else if (Array.isArray(user.profile[tokenConstants.ROLES])) {
                    userHasRoles = requiredRoles.every(role =>
                        user.profile[tokenConstants.ROLES].includes(role)
                    )
                }
            }

            setIsAuthenticated(true)
            setHasRoles(rolesRequired ? userHasRoles : true)
            setIsLoading(false)
        }
        initialiseAccessData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const roleGuardedRoute = props => {
        if (!isAuthenticated) {
            signInRedirect({
                state: {
                    originalUrl: window.location.href,
                    postLoginRedirect:
                        window.location.pathname + window.location.search,
                },
            })
            return
        }

        if (!hasRoles)
            return (
                <Redirect
                    to={{
                        pathname: '/permissions',
                        state: { from: location.pathname },
                    }}
                />
            )

        return serviceSelectedRequired ? (
            <ServiceSelectionRequired>
                <Component {...props} />
            </ServiceSelectionRequired>
        ) : (
            <Component {...props} />
        )
    }

    return isLoading ? (
        <LoadingPage text='Checking permissions' />
    ) : (
        <Route {...rest} render={props => roleGuardedRoute(props)} />
    )
}

ProtectedRoute.propTypes = {
    requiredRoles: PropTypes.arrayOf(PropTypes.oneOf([roleConstants.ADMIN])),
    component: PropTypes.func.isRequired,
}

export default ProtectedRoute
